import * as React from 'react';
import { useInfrastructureProps } from './hooks';
import { MobileInfrastructureContainer } from './MobileInfrastructureContainer';
import { IInfrastructureContainerLoadProps } from './utils';
import { RefWrapper } from '../../components/packages/RefWrapper';

export const MobileInfrastructureContainerLoad: React.FC<IInfrastructureContainerLoadProps> = ({ refWrapper }) => {
  const infrastructureProps = useInfrastructureProps();

  if (!infrastructureProps) {
    return null;
  }

  return refWrapper(
    <RefWrapper>
      <MobileInfrastructureContainer {...infrastructureProps} />
    </RefWrapper>,
  );
};
